{
  "timetable": {
    "label": "Session Times",
    "events.short_title": "Prf{{preference}} Pri{{priority}}",
    "events.short_title_all_subjects": "Prf{{preference}} Pri{{priority}} {{subject_code}}",
    "schedule": {
      "duration": "{{duration}} minutes",
      "fixed": "Day {{day}} {{start}} - {{end}}",
      "fixed_timezone": "(Day {{day}} {{start}} - {{end}} {{timezone}})",
      "subject": "Subject: {{name}}",
      "custom_class_name": "Class: {{name}}",
      "educator_name": "Educator: {{name}}",
      "invalid": "This student does not meet the criteria to be in this class",
      "conflicts": "This preference cannot conflict with another subject",
      "full_rank_details": "Preference {{preference}} Priority {{priority}}"
    }
  },
  "publish": {
    "label": "Publish",
    "title": "Publish Subjects",
    "pending": "Publishing...",
    "description": "This action cannot be undone. You may change your preferences until the deadline date.",
    "success": "Preferences published successfully.",
    "error": "An error occurred while publishing preferences. Please refresh and try again.",
    "subjects.description": "Choose a subject to publish. You may change your preferences until the deadline date."
  },
  "edit": {
    "class.combobox.item": "{{className}} by {{educatorName}}",
    "class.label": "Class",
    "preference.invalid.title": "Invalid Preference",
    "preference.invalid.description": "This preference is invalid. Please remove it to publish your preferences.",
    "title": "Assign Preferences",
    "students.title": "Select Students to Assign Preferences",
    "students.combobox.select": "Select Students",
    "students.selected.label": "Selected Students",
    "class.add": "Add Class",
    "class.preferences.label": "Preference Structure",
    "class.combobox.label": "Add Class",
    "class.combobox.placeholder": "Select a class",
    "class.schedule.label": "Timetable Options",
    "class.preference.schedule.priorities_list_label": "Priorities",
    "class.preference.schedule.priority": "Priority: {{priority}}",
    "class.preference.schedule.close": "Close",
    "class.preference.schedule.update": "Update Schedule",
    "class.preference.schedule.select": "Select Schedule",
    "class.preference.schedule.duration": "{{duration}} minutes",
    "class.preference.schedule.fixed": "Day {{day}} {{start}} - {{end}}",
    "class.preference.label": "Pref {{rank}}",
    "class.preference.ranking.increase": "Increase Rank",
    "class.preference.ranking.decrease": "Decrease Rank",
    "class.preference.ranking.no_increase": "Cannot Increase Rank - already at maximum rank",
    "class.preference.ranking.no_decrease": "Cannot Decrease Rank - already at minimum rank",
    "class.preference.live": "Live",
    "class.preference.live.description": "You have been allocated to the class and it will go ahead at the agreed upon dates and times for the duration of the class.",
    "class.preference.allocated": "Allocated",
    "class.preference.allocated.description": "You have been allocated to this class but it is not yet live. A teacher may still choose to go live or you can request to upgrade your preference 2.",
    "class.preference.unavailable": "Unavailable",
    "class.preference.unavailable.description": "This class has been filled and you have not been allocated to it.",
    "class.educator.label": "Educator"
  },
  "class.preference": {
    "student_count_one": "{{allocated}} of {{count}} student",
    "student_count_other": "{{allocated}} of {{min}} - {{count}} students"
  },
  "errors": {
    "create.conflicting_versions": "Sorry an error occurred creating the preference. Please try again.",
    "no_students": "Please select at least one student.",
    "no_preferences": "Please select at least one preference.",
    "zero_priorities": "Preference {{rank}} cannot have zero selected priorities.",
    "overlap_priorities": "Preference's from the same class cannot overlap priorities.",
    "conflicts.title": "Error: Conflicts",
    "conflicts.description": "Preferences cannot conflict with different subjects.",
    "eligibility.title": "Error: Student ineligible for class.",
    "eligibility.description": "This student does not meet the speciality criteria the educator has set for this class. Replace this preference with another class to publish these preferences.",
    "invalid.title": "Error: A preference for this subject is invalid",
    "invalid.description": "A preference for this subject is invalid. Please remove it to publish your preferences."
  },
  "show": {
    "title": "Preferences",
    "class.preference.label": "Preference {{rank}}",
    "actions": {
      "upgrade": "Request Upgrade",
      "upgrade_description": "This action cannot be undone. You are making a request to upgrade your preference 2 into a preference 1. This request will only be accepted should your preference 1 choose not to go live.",
      "upgrade_pending": "Requesting an upgrade...",
      "upgrade_success": "A successful request has been made to upgrade your preference 2.",
      "upgrade_error": "An unexpected error occured. Please try again."
    }
  },
  "deleted": {
    "message": "This class has been withdrawn. Please re-assign preferences for {{subjectName}}."
  },
  "new": {
    "add": "Add Preference"
  },
  "preference_sheet": {
    "title": "Preference: {{rank}}",
    "class_name": "Class: {{name}}",
    "description": "Pick one or more priority schedule from {{educatorName}}",
    "priority.description": "Priority already preferenced in Preference {{rank}}",
    "priority.select": "Select",
    "priority.move": "Move",
    "priority.deselect": "Deselect"
  },
  "tabs": {
    "shortlists": "Shortlists",
    "saved_classes": "Saved Classes"
  },
  "shortlist_sheet": {
    "title": "Add a class from a shortlist",
    "shortlists_label": "Shortlists",
    "loading": "Loading shortlists…",
    "error": "Your shortlists could not be loaded. Please try again.",
    "empty_title": "No Shortlists",
    "empty_description": "Create a shortlist in search, then add its classes here.",
    "create_shortlist": "Create Shortlist",
    "view_classes": "View Saved Classes",
    "class_count_one": "{{count}} class",
    "class_count_other": "{{count}} classes",
    "educator_count_one": "{{count}} educator",
    "educator_count_other": "{{count}} educators",
    "back": "Back",
    "include_educator_classes": "Include classes listed by shortlisted educators",
    "filter_label": "Filter classes by name",
    "filter_placeholder": "Search for a class by name",
    "filters": "Filters",
    "clear_filters": "Clear",
    "classes_loading": "Loading classes…",
    "classes_error": "The shortlist's classes could not be loaded. Please try again.",
    "classes_empty_title": "No classes found",
    "classes_empty_description": "No classes in this shortlist match your filters.",
    "class_size": "Class Size",
    "class_size_range": "{{min}} - {{max}} students",
    "timezone": "Timezone",
    "educator": "Educator",
    "choose_educator": "Choose an Educator:",
    "pagination": "Pages of classes",
    "paging": "Page {{page}} of {{pageCount}}",
    "previous_page": "Previous",
    "next_page": "Next"
  }
}
